module.exports = __webpack_public_path__ + "static/media/johnmark.8ba5eb0d.jpg";